import { CSSProperties } from 'react';
import styled from 'styled-components';

function UnstyledSolidHexagon(props: {
    width?: number | string | undefined;
    height?: number | string | undefined;
    className?: string | undefined;
    style?: CSSProperties | undefined;
}) {
    return <svg viewBox="10 0 170 214" className={props.className} width={props.width ?? '100%'} height={props.height ?? '100%'} style={props.style}>
        <g fill="white">
            <path d="M92.79,4.551C94.209,3.737 96.531,3.737 97.951,4.551L183.808,53.807C184.513,54.212 185.108,54.949 185.568,55.739C186.024,56.525 186.369,57.399 186.369,58.204L186.369,156.709C186.369,157.513 186.024,158.388 185.568,159.173C185.108,159.964 184.513,160.701 183.808,161.105L97.95,210.358C96.531,211.173 94.209,211.172 92.79,210.359L71.647,198.23L62.506,192.987L6.93,161.106C6.225,160.701 5.629,159.964 5.17,159.173C4.714,158.388 4.369,157.513 4.369,156.709L4.369,58.204C4.369,57.399 4.714,56.525 5.17,55.739C5.629,54.949 6.225,54.212 6.93,53.807L92.79,4.551Z"/>
        </g>
    </svg>;
}

export const SolidHexagon = styled(UnstyledSolidHexagon)`
    width: auto;
`;
